import { render, staticRenderFns } from "./etcDetail.vue?vue&type=template&id=734e1be2&scoped=true&"
import script from "./etcDetail.vue?vue&type=script&lang=js&"
export * from "./etcDetail.vue?vue&type=script&lang=js&"
import style0 from "./etcDetail.vue?vue&type=style&index=0&id=734e1be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734e1be2",
  null
  
)

export default component.exports